export const formatCustomerGroup = (str: string) => {
  return str?.toLowerCase().replace(/[-_]([a-z])/g, function (match, letter) {
    return letter.toUpperCase();
  });
};
